import { createApi } from '@reduxjs/toolkit/query/react';

import { ENVS } from '@/shared/consts';

import { publicBaseQueryWithReauth } from '../queries/publicBaseQueryWithReauth';

export const mainService = createApi({
  reducerPath: 'mainApi',
  tagTypes: [],
  baseQuery: publicBaseQueryWithReauth({
    baseUrl: ENVS.API_BASEURL,
  }),
  endpoints: () => ({}),
});
